@if (showDropdownMenu) {
    <div class="background" (click)="toggleDropdown()"></div>
}
<div class="dropdown" [ngClass]="{ disabled: disabled, invalid: !disabled && mandatory && !selectedOption }">
    <div class="input-group" (click)="toggleDropdownFromMenu($event)">
        <div class="form-control flex-grow-1 dropdown-display" #dropDownButton>
            {{ selectedOption?.value || 'F4M_CONTENT_RENDER_SELECT_ANSWER_LABEL' | translate }}
        </div>
        <div class="d-flex">
            <fa-icon [icon]="faCaretDown" class="input-group-text"></fa-icon>
        </div>
    </div>
    <ul class="dropdown-menu" #dropDownMenu role="menu" [ngClass]="{ show: showDropdownMenu }">
        @for (option of options; track option) {
            <li role="menuitem">
                <a
                    class="dropdown-item"
                    (click)="selectOption(option)"
                    [ngClass]="{ 'highlight-selection': option === selectedOption }"
                    >{{ option.value }}</a
                >
            </li>
        }
    </ul>
</div>
